<section id="about" class="about">
  <div class="about-inner">
    <div class="about-top">
      <div class="about-photo">
        <img [src]="portrait" [alt]="'about.photoAlt' | translate" />
      </div>
      <div class="about-story">
        <div ppcEyebrow mark>{{ 'about.eyebrow' | translate }}</div>
        <h2 ppcHeading class="about-title">{{ 'about.title' | translate }}</h2>
        <div class="about-paragraphs">
          @for (paragraph of head(); track $index) {
            <p [class.about-dim]="$index > 0">{{ paragraph }}</p>
          }
        </div>

        <div class="about-section">
          <div ppcEyebrow class="about-heading">{{ 'about.palmaresHeading' | translate }}</div>
          <div class="about-palmares">
            @for (achievement of palmares(); track $index) {
              <div class="about-palmares-row">
                <span class="about-palmares-label">{{ achievement.label }}</span>
                <span ppcHeading size="sm" class="about-palmares-num">{{ achievement.num }}</span>
              </div>
            }
          </div>
        </div>
      </div>
    </div>

    <div class="about-bottom">
      @for (paragraph of tail(); track $index) {
        <p>{{ paragraph }}</p>
      }
    </div>
  </div>
</section>
